import { useState } from 'react';
import NotesGate from './NotesGate';

const SESSION_KEY = 'sbs_notes_unlocked';

export default function NotesGuard({ children }) {
  const [unlocked, setUnlocked] = useState(
    () => sessionStorage.getItem(SESSION_KEY) === 'true'
  );

  if (!unlocked) {
    return <NotesGate onUnlock={() => setUnlocked(true)} />;
  }

  return children;
}
